import { useEffect, useState } from "react";
import DashBoardCard from "./DashBoardCard";
import audioIcon from "../../image/audioAssetLams.svg";
import graphicIcon from "../../image/graphicAssetLams.svg";
import "../../Sass/app.scss";
import { Layout } from "../../components";
import { API_URL } from "src/service/config";
import { getRequest } from "src/service/api-services/api-services";

interface ApiCountResponse {
  status: string;
  message: "success" | "error";
  result: {
    total: number;
  };
}

function Dashboard() {
  const [data, setData] = useState({
    total_audios: 0,
    total_graphics: 0,
    total_videos: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAllCounts = async () => {
      setLoading(true);
      try {
        const [graphicRes, audioRes, videoRes] = await Promise.all([
          getRequest<ApiCountResponse>(`${API_URL}/graphics/count`),
          getRequest<ApiCountResponse>(`${API_URL}/audios/count`),
          getRequest<ApiCountResponse>(`${API_URL}/videos/count`),
        ]);

        setData({
          total_graphics: graphicRes.result.total,
          total_audios: audioRes.result.total,
          total_videos: videoRes.result.total,
        });
      } catch (error) {
        console.error("Error loading asset counts", error);
      } finally {
        setLoading(false);
      }
    };

    loadAllCounts();
  }, []);

  if (loading) {
    return <p className="text-center mt-8">Loading dashboard...</p>;
  }

  return (
    <Layout>
      <section className="grid grid-cols-3 gap-4 p-8">
        <DashBoardCard
          title="Audio Asset"
          count={data.total_audios ?? 0}
          link="dashboard/audios"
          // upload="upload"
          image={audioIcon}
        />
        <DashBoardCard
          title="Graphics Asset"
          count={data.total_graphics ?? 0}
          link="dashboard/graphics"
          // upload="upload"
          image={graphicIcon}
        />
        {/* <DashBoardCard
          title="Instruction Asset"
          count={6}
          link="dashboard/list"
          // upload="upload"
          image={instructionIcon}
        /> */}
        <DashBoardCard
          title="Video Asset"
          count={data.total_videos ?? 0}
          link="dashboard/videos"
          // upload="upload"
          image={audioIcon}
        />

        <DashBoardCard
          title="Activity Question and Answer"
          count={6}
          link="dashboard/levels"
          // upload="questions/create"
          image={graphicIcon}
        />
      </section>
    </Layout>
  );
}

export default Dashboard;
